import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatusCellLocalStoreService } from './status-cell-local-store.service';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-status-cell',
    templateUrl: './status-cell.component.html',
    styleUrls: ['../../../../../../assets/scss/partials/status-filter-icon-styling.scss',
                './status-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [StatusCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, NgxSkeletonLoaderModule, MatIcon, MatTooltip]
})
export class StatusCellComponent extends AgCellRendererComponent {

  viewModel$ = this.localStore.viewModel$;

  constructor(protected localStore: StatusCellLocalStoreService) {
    super(localStore);
  }

  /**
   * Returns information for the user (will be shown in a tooltip) for a location status
   * @param status Location status (e.g. notFound,...)
   */
  getFurtherLocationStatusInfo(status: string): string {
    switch (status) {
      case 'permanentlyClosed':
        return 'This location is permanently closed.';
      case 'temporarilyClosed':
        return 'This location is temporarily closed.';
      case 'updateError':
        return 'An update error has occurred for this location.';
      case 'importError':
        return 'An import error has occurred for this location.';
      case 'differences':
        return 'This location has different information in GBP.';
      case 'accepted':
        return 'Differences have been accepted for this location.';
      case 'missing':
        return 'This location hasn\'t been found in GBP.';
      case 'archived':
        return 'This location has been archived.';
      case 'blacklisted':
        return 'This location has blacklisted fields.';
      case 'notManaged':
        return 'This location doesn\'t get managed by gXperts.';
      case 'manuallyManaged':
        return 'This location is managed manually by gXperts.';
      case 'unverified': //todo rename BLS-2470
        return 'This location hasn\'t been validated yet.';
      case 'ccCompleted': {
        return 'Claim & Clean was completed for this location.';
      }
      default:
        return '';
    }
  }

}
